import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminLessonActions'
import {
  ACKNOWLEDGE_TUTORIAL,
  SAVE_LESSON_SEQUENCE,
  SELECT_LESSON_SEQUENCE
} from '../../actions/admin/adminLessonActions'
import { ACKNOWLEDGEMENT_LOADED, ADMIN_LESSON_TUTORIAL_1 } from '../../actions/tutorials'

const {
  initialLessonModel,
  initialLessonSequenceModel,
  initialPrivilegedModel,
  initialTaskModel,
  MERGE_STATE
} = actions
const initialCopyModel = { name: '' }
const initialViewState = {
  taskIndex: 1,
  showTutorial: false
}
const initialRejectionState = {
  comment: ''
}
const initialApprovalFormState = {
  savePDF: false,
  tagId: null
}
const viewState = (state = initialViewState, action) => {
  if (action.type === MERGE_STATE) {
    return { ...state, ...action.state }
  }

  if (action.type === ACKNOWLEDGEMENT_LOADED) {
    if (action.key === ADMIN_LESSON_TUTORIAL_1) {
      return {
        ...state,
        showTutorial:
          action.details.acknowledgement &&
          action.details.acknowledgement.dateAcknowledged == null
      }
    }

    return state
  }

  if (action.type === ACKNOWLEDGE_TUTORIAL) {
    return { ...state, showTutorial: false }
  }

  return state
}
const initialEditState = { selected: null }
const adminEditLesson = (state = initialEditState, action) => {
  switch (action.type) {
    case actions.SELECT_LESSON_FOR_EDIT:
      return {
        ...state,
        selected: action.selected
      }
    default:
      return state
  }
}

export default combineReducers({
  queueRequest: h2Api.restReducer(actions.LOAD_QUEUE),
  queueEntriesRequest: h2Api.restReducer(actions.LOAD_QUEUE_LIST),
  listRequest: h2Api.restReducer(actions.LOAD_LESSONS, {
    result: { lessons: [], count: 0 }
  }),
  loadSequenceRequest: h2Api.restReducer(actions.SELECT_LESSON_SEQUENCE),
  taskTypesRequest: h2Api.restReducer(actions.LOAD_TASK_TYPES, { result: [] }),
  saveRequest: h2Api.restReducer(actions.SAVE_LESSON),
  selectRequest: h2Api.restReducer(actions.SELECT_LESSON),
  updateRequest: h2Api.restReducer(actions.UPDATE_LESSON),
  privilegedRequest: h2Api.restReducer(actions.UPDATE_PRIVILEGED),
  assignRequest: h2Api.restReducer(actions.ASSIGN_LESSON),
  unassignRequest: h2Api.restReducer(actions.UNASSIGN_LESSON),
  deleteRequest: h2Api.restReducer(actions.DELETE_LESSON),
  copyRequest: h2Api.restReducer(actions.COPY_LESSON),
  saveTaskRequest: h2Api.restReducer(actions.SAVE_TASK),
  updateTaskRequest: h2Api.restReducer(actions.UPDATE_TASK),
  rootMarkCompleteRequest: h2Api.restReducer(actions.ROOT_MARK_COMPLETE),
  learningStandardsRequest: h2Api.restReducer(actions.LIST_LEARNING_STANDARDS),
  saveSequenceRequest: h2Api.restReducer(actions.SAVE_LESSON_SEQUENCE),
  updateSequenceRequest: h2Api.restReducer(actions.UPDATE_LESSON_SEQUENCE),
  adminEdit: adminEditLesson,
  lessonForm: modelReducer('admin.lessons.lessonForm', initialLessonModel),
  lessonSequenceForm: modelReducer(
    'admin.lessons.lessonSequenceForm',
    initialLessonSequenceModel
  ),
  privilegedForm: modelReducer('admin.lessons.privilegedForm', initialPrivilegedModel),
  copyForm: modelReducer('admin.lessons.copyForm', initialCopyModel),
  taskForm: modelReducer('admin.lessons.taskForm', initialTaskModel),
  approvalRejectionForm: modelReducer(
    'admin.lessons.approvalRejectionForm',
    initialRejectionState
  ),
  approvalApprovalForm: modelReducer(
    'admin.lessons.approvalApprovalForm',
    initialApprovalFormState
  ),
  forms: formReducer('admin.lessons', {
    approvalRejectionForm: initialRejectionState,
    approvalApprovalForm: initialApprovalFormState,
    lessonSequenceForm: initialLessonSequenceModel,
    lessonForm: initialLessonModel,
    privilegedForm: initialPrivilegedModel,
    copyForm: initialCopyModel,
    taskForm: initialTaskModel
  }),
  viewState
})
